import { VoyageModel } from '../models/voyage.model';

/**
 * Builds a human-readable display name for a voyage.
 *
 * Format: `"<reference> - <vesselName>"` when both are available;
 * otherwise returns whichever is present, or an empty string.
 *
 * @param voyage - The voyage model to format. Returns `''` if not provided.
 * @returns A display string suitable for dropdowns, labels, or list items.
 *
 * @example
 * voyageNameTemplate(voyage) // "V-2024-01 - MV Atlantic"
 * voyageNameTemplate(voyage) // "V-2024-01"  (no vessel name)
 * voyageNameTemplate()       // ""
 */
export const voyageNameTemplate = (voyage?: VoyageModel): string => {
  if (!voyage) return '';
  const reference = voyage.getReference() ?? '';
  const vessel = voyage.vesselDetails?.vesselName ?? '';
  if (reference && vessel) return `${reference} - ${vessel}`;
  return reference || vessel || '';
};
